import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollResetOnNavigate = (scrollContainerRef) => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;

    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [pathname, hash, scrollContainerRef]);
};
